import { render, staticRenderFns } from "./FacialRecognitionSearch.vue?vue&type=template&id=0f7d754b&"
import script from "./FacialRecognitionSearch.vue?vue&type=script&lang=js&"
export * from "./FacialRecognitionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports